import React, { useEffect, useId, useState } from 'react'
import cx from 'classnames'
import { useButton } from 'react-aria'

import { RichTextProps } from '../RichText'

import * as SC from './styled'

export type TranscriptProps = {
  className?: string
  texts: {
    open?: string
    close?: string
  }
  richTextProps?: RichTextProps
  open: boolean
  toggleHandler?: () => void
}

const Transcript = React.forwardRef<HTMLDivElement, TranscriptProps>(
  ({ className, texts, richTextProps, open, toggleHandler }, ref) => {
    const id = useId()
    const [heightContent, setHeightContent] = useState(250)
    const refButton = React.useRef<HTMLButtonElement>(null)
    const refContent = React.useRef<HTMLDivElement>(null)

    const handleHeight = () => {
      if (refContent.current) {
        setHeightContent(refContent.current.clientHeight)
      }
    }

    const handleToggle = () => {
      handleHeight()
      toggleHandler?.()
    }

    const { buttonProps } = useButton(
      {
        id: `${id}-button`,
        'aria-controls': `${id}-content`,
        onPress: handleToggle,
        'aria-expanded': open,
        type: 'button',
      },
      refButton
    )

    // get height of the content on load and resize
    useEffect(() => {
      // delayed version because inside the slider it was not going great ):
      const handleHeightDelayed = () => {
        setTimeout(handleHeight, 300)
      }
      // on load
      handleHeightDelayed()
      // on resize
      window.addEventListener('resize', handleHeightDelayed)
      return () => window.removeEventListener('resize', handleHeightDelayed)
    }, [])

    return richTextProps ? (
      <SC.Container
        className={cx('Transcript', className)}
        data-open={open}
        ref={ref}
      >
        <SC.Toggle ref={refButton} {...buttonProps} tabIndex={0}>
          <SC.LabelOn>{texts.open}</SC.LabelOn>
          <SC.LabelOff>{texts.close}</SC.LabelOff>
        </SC.Toggle>
        <SC.Wrapper
          hidden={!open}
          id={`${id}-content`}
          $height={heightContent}
          aria-labelledby={`${id}-button`}
        >
          <SC.Content ref={refContent} data-height={heightContent}>
            <SC._RichText {...richTextProps} />
          </SC.Content>
        </SC.Wrapper>
      </SC.Container>
    ) : null
  }
)

Transcript.displayName = 'Transcript'

export default Transcript
